module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('failed')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cfd0da6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finance/deposit-return/FasapayFailed.vue
// module id = 724
// module chunks = 0